// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"359":"cf8d43da","361":"22d850ae","767":"4261832c"}[chunkId] + ".chunk.js";
};